import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../hooks';
import { EventsService } from '../../../../services/EventsService';
import CustomTooltip from '../../../../components/CustomToolTip/CustomTooltip';
import { UilInfoCircle } from '@iconscout/react-unicons';
import { momentTimeFormater } from '../../../../utils/timeHelper';
import _ from 'lodash';

import Table from '../../../../components/Table/Table';
import classes from '../../../../styles/AllDevices.module.css';
import { toast } from 'react-toastify';
import Typography from '../../../../components/Typography/Typography';
import ModalComponent from '../../../../components/ModalComponent/ModalComponent';
import { Form, Formik } from 'formik';
import NewJSONEditor from '../../../../components/JSONEditor/NewJSONEditor';

const LIMIT = 15;

const EventsLogModal = ({ setOpen, id = '' }) => {
    const [startLoader, stopLoader] = useLoader();

    const [data, setData] = useState([]);
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const [reqResModal, setReqResModal] = useState({ status: false, type: '', data: '' })

    useEffect(() => {
        getLogs();
    }, [skip, id]);

    const getLogs = () => {
        if (id) {
            const params = {
                limit: LIMIT,
                skip,
            };
            EventsService.GetLogs(id, params, startLoader, handleSuccess, handleError, stopLoader);
        }
    };

    const handleSuccess = ({ data }) => {
        const processedData = _.get(data, ['data', 'eventLogs'], []).map((item) => ({
            type: item.type,
            reason:
                !item.reason ? (
                    '--'
                ) : item.reason.length > 120 ? (
                    <CustomTooltip content={`${item?.reason}`}>{item?.reason.substring(0, 120) + '...'}</CustomTooltip>
                ) : (
                    `${item?.reason}`
                ),
            request: item.request ? (<div onClick={() => {
                setReqResModal({
                    status: true,
                    type: 'Request',
                    data: item.request
                });
            }}>
                <CustomTooltip content={'Request Info'}>
                    <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                </CustomTooltip>
            </div>) : '--',
            response: item.response ? (<div onClick={() => {
                setReqResModal({
                    status: true,
                    type: 'Response',
                    data: item.response
                });
            }}>
                <CustomTooltip content={'Response Info'}>
                    <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                </CustomTooltip>
            </div>) : '--',
            timestamp: momentTimeFormater(item.timestamp).format('YYYY-MM-DD HH:mm:ss'),
        }));
        setTotalCount(_.get(data, ['data', 'totalCount'], 0));
        setData(processedData);
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    return (
        <div style={{ minWidth: '80vw', maxHeight: '90vh', overflowY: 'scroll' }}>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <div>
                        <Typography content={`Event Logs`} />
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={data.length} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <Table
                head={['TYPE', 'REASON', 'REQUEST', 'RESPONSE', 'TIMESTAMP (CET)']}
                keys={['type', 'reason', 'request', 'response', 'timestamp']}
                data={data}
                page={page}
                Pagination={true}
                limit={LIMIT}
                handlePageChange={handlePageChange}
                totalCount={totalCount}
            />
            <div className={classes.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>

            <ModalComponent isOpen={reqResModal.status} setOpen={() => setReqResModal({
                status: false,
                type: '',
                data: ''
            })}>
                <div style={{ minWidth: '60vw', maxHeight: '90vh', overflowY: 'auto' }}>
                    <div className={classes.AllDevices}>
                        <div className={classes.Header}>
                            <Typography content={reqResModal.type}></Typography>
                        </div>
                    </div>
                    {
                        reqResModal?.data ? (<Formik initialValues={{ ...reqResModal?.data }}>
                            {() => {
                                return (
                                    <Form>
                                        <NewJSONEditor name={reqResModal.type} defaultValue={reqResModal?.data} height="15rem" />
                                    </Form>
                                );
                            }}
                        </Formik>) : null
                    }


                    <div className={classes.ButtonContainer}>
                        <div className="btn-secondary" onClick={() => setReqResModal({
                            status: false,
                            type: '',
                            data: ''
                        })}>
                            Close
                        </div>
                    </div>
                </div>
            </ModalComponent>
        </div>
    );
};

export default EventsLogModal;
